import { ApplicationInsights } from '@microsoft/applicationinsights-web';

const CONNECTION_STRING = 
  process.env.REACT_APP_APPINSIGHTS_CONNECTION_STRING || 
  process.env.REACT_APP_AZURE_MONITOR_CONNECTION_STRING;

let appInsights = null;

export function initAzureMonitor() {
  if (!CONNECTION_STRING || CONNECTION_STRING.indexOf('%') === 0) {
    return null;
  }

  if (appInsights) return appInsights;

  try {
    appInsights = new ApplicationInsights({
      config: {
        connectionString: CONNECTION_STRING.trim(),
        enableAutoRouteTracking: true,
        disableFetchTracking: false,
        enableCorsCorrelation: true,
      }
    });
    appInsights.loadAppInsights();
    return appInsights;
  } catch (err) {
    console.warn('Failed to initialize Azure Monitor Application Insights:', err);
    return null;
  }
}

/**
 * Sets authenticated user context (userId and account/tenantId).
 * Slices product telemetry per user and customer tenant.
 */
export function setUserContext(userId, accountId = null) {
  if (!appInsights) return;
  try {
    appInsights.setAuthenticatedUserContext(userId, accountId || undefined, true);
  } catch (err) {
    console.debug('Failed to set Azure Monitor user context:', err);
  }
}

/** Clears authenticated user context on logout. */
export function clearUserContext() {
  if (!appInsights) return;
  try {
    appInsights.clearAuthenticatedUserContext();
  } catch (err) {
    console.debug('Failed to clear Azure Monitor user context:', err);
  }
}

/** Tracks a custom page view / route in Azure Monitor. */
export function trackPageView(name, properties = {}) {
  if (!appInsights) return;
  try {
    appInsights.trackPageView({ name, properties });
  } catch (err) {
    console.debug('Failed to track Azure Monitor page view:', err);
  }
}

/** Tracks a custom business event in Azure Monitor. */
export function trackEvent(name, properties = {}) {
  if (!appInsights) return;
  try {
    appInsights.trackEvent({ name, properties });
  } catch (err) {
    console.debug('Failed to track Azure Monitor event:', err);
  }
}

/** Tracks an unhandled exception or error in Azure Monitor. */
export function trackException(error, properties = {}) {
  if (!appInsights) return;
  try {
    appInsights.trackException({ exception: error, properties });
  } catch (err) {
    console.debug('Failed to track Azure Monitor exception:', err);
  }
}
